// https://codingreflections.com/hide-header-on-scroll-down/
const InitHeaderOnScroll = () => {
  const doc = document.documentElement;
  const w = window;

  let curScroll;
  let prevScroll = w.scrollY || doc.scrollTop;
  let curDirection = 0;
  let prevDirection = 0;

  const header = document.querySelector('.site--header');
  const scrollTop = document.querySelector('.scrollTop');
  const threhold = 200;
  let toggled;

  const toggleHeader = () => {
    toggled = true;
    if (curDirection === 2 && curScroll > threhold) {
      header.classList.add('is-hidden');
    } else if (curDirection === 1) {
      header.classList.remove('is-hidden');
    } else {
      toggled = false;
    }
    return toggled;
  };
  const checkScroll = () => {
    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) {
      // scrolled down
      curDirection = 2;
    } else {
      // scrolled up
      curDirection = 1;
    }

    if (curDirection !== prevDirection) {
      toggled = toggleHeader();
    }

    prevScroll = curScroll;
    if (toggled) {
      prevDirection = curDirection;
    }
    if (curScroll > threhold) {
      scrollTop.classList.remove('is-hidden');
    } else {
      scrollTop.classList.add('is-hidden');
    }
  };

  window.addEventListener('scroll', checkScroll);

  scrollTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
};
export default InitHeaderOnScroll;
